import React from 'react';
import classNames from 'classnames';
import styles from '../assets/invoicesChanges-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IInvoiceDoc } from 'src/types/invoice';
import { CellProps } from 'react-table';
import InvoiceChangeActionsColumn from './InvoiceChangeActionsColumn';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';

interface Props {
    data: Paginated<IInvoiceDoc>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IInvoiceDoc>[] = [
    {
        Header: 'Invoice #',
        accessor: 'invoice.id',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoiceDoc>) => {
            if (!original?.invoice?.provider) return '';

            return (
                <Link
                    className={'btn btn-info'}
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.invoice?.provider?.id,
                        tab: 'invoices-detail',
                        subId: original.invoice.id,
                    })}
                >
                    {original.invoice?.id}
                </Link>
            );
        },
        Filter: textFilter<IInvoiceDoc>(),
    },
    {
        Header: 'Provider Full Name',
        accessor: 'original.invoice.provider.id',
        disableFilters: true,
        disableSortBy: true,
        Filter: textFilter<IInvoiceDoc>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoiceDoc>) => {
            if (!original?.invoice?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.invoice?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.invoice?.provider?.fullName}
                </Link>
            );
        },
    },
    {
        Header: 'Invoice original document',
        accessor: 'name',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoiceDoc>) => {
            return <a href={`${original.attach}`}>{original.name}</a>;
        },
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IInvoiceDoc>(),
    },
    {
        Header: 'Invoice uploaded document',
        accessor: 'attachSigned',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoiceDoc>) => {
            return <a href={`${original.attachSigned}`}>{original.attachSignedName}</a>;
        },
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IInvoiceDoc>(),
    },
    {
        Header: 'Actions',
        accessor: 'mimeType',
        Cell: InvoiceChangeActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '20%',
    },
];

const InvoiceDocsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => {
    /*
     const filtersInit: any = [];
     const match: any = useRouteMatch();
    if (Object.values(match.params).length && match.params.param) {
        filtersInit.push({ id: 'isApprove', value: +match.params.param });
    }*/
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IInvoiceDoc>
                columns={columns}
                filtersInit={[{ id: 'isApproved', value: false }]}
                data={data}
                getData={getData}
            />
        </div>
    );
};

export default InvoiceDocsGrid;
